/** Absolute implementation bounds. Commercial limits are supplied by the server. */
export const VIDEO_SAFETY_SECONDS = 240;
export const VIDEO_FPS = 30;
export const DEFAULT_PAID_VIDEO_SECONDS = VIDEO_SAFETY_SECONDS;
export const TRIAL_MAX_VIDEO_SECONDS = 90;
export const DEFAULT_TRIAL_VIDEO_SECONDS = TRIAL_MAX_VIDEO_SECONDS;

export function assertVideoBudget(seconds: number, maximum: number): void {
  const limit = Math.min(maximum, VIDEO_SAFETY_SECONDS);
  if (!Number.isInteger(maximum) || maximum < 5
    || !Number.isInteger(seconds) || seconds < 5 || seconds > limit) {
    throw new RangeError(`Video length must be between 5 and ${limit} whole seconds.`);
  }
}
